import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  left: -9999px;
  position: absolute;
`;

// Without this invisible form, Netlify won't register our actual modal form  ¯\_(ツ)_/¯

export default () => (
  <Wrapper>
    <form
      name="contact"
      action={typeof window !== `undefined` ? window.location.pathname : ""}
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
    >
      <p className="hidden">
        <label>
          Don’t fill this out if you're human: <input name="bot-field" />
        </label>
      </p>
      <p>
        <label>Naam </label>{" "}
        <input className="input" type="text" name="name" required />
      </p>

      <p>
        <label>Leerlingcode </label>{" "}
        <input className="input" type="text" name="email" required />
      </p>

      <p>
        <label>Feedback </label>{" "}
        <textarea className="input" name="message" required />
      </p>

      <input type="hidden" name="form-name" value="contact" />

      <button type="submit" className="submit">
        Verzenden
      </button>
    </form>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/layout/feedback/InvisibleForm.js